const Footer = () => {
  return <footer className="py-5 bg-gray-700 text-center text-white">
    <a target="_blank" rel="noreferrer" href="https://www.relias.de">
      &copy;{new Date().getFullYear()} Relias Learning GmbH
    </a>
  </footer>;
};
export {Footer};
